import React, { useEffect, useState } from 'react'
import Slider from 'react-slick'
import './c.css'
import { getInitials } from '../../../../Utility'

const getSlideCount = () => {
    const w = window.innerWidth > 0 ? window.innerWidth : window.screen.width
    return w < 1200 ? 1 : 3
}

const ContactV = ({ transporter_data }) => {
    const contacts = transporter_data?.contact_information ?? []
    const [slidesToShow, setSlidesToShow] = useState(getSlideCount)

    useEffect(() => {
        const handleResize = () => setSlidesToShow(getSlideCount())
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow,
        slidesToScroll: 1,
        className: 'contactCard',
    }

    return (
        <div className="container contact_Details_Body">
            {contacts.length > 0 ? (
                <Slider {...settings}>
                    {contacts.map((index, i) => (
                        <div className="contactCardBody" key={i}>
                            <div className="row">
                                <div className="upperSection">
                                    <div className="col-md-3 contact_image">
                                        {index.profile_image ? (
                                            <img src={index.profile_image} alt="" />
                                        ) : (
                                            <div className="avatar-circle">
                                                <span className="initials">{getInitials(index.name)}</span>
                                            </div>
                                        )}
                                    </div>
                                    <div className="col-md-9 personal">
                                        <span className="name"><b>{index.name} </b></span><br />
                                        <span className="designation">{index.designation}</span>
                                    </div>
                                </div>
                                <div className="col-md-12 text-center" style={{ paddingBottom: '10px' }} />
                            </div>
                        </div>
                    ))}
                </Slider>
            ) : (
                <>
                    <h4 className="data_header">Contact Information</h4>
                    <span>Details not available</span>
                </>
            )}
            <br />
        </div>
    )
}

export default ContactV
